import Vue from 'vue'
import Router from 'vue-router'
import home from '@/page/home'
import order from '@/page/order'
import canteen from '@/page/canteen'
import search from '@/page/search'
import mine from '@/page/mine'
import problem from '@/page/problem'
import problemDetail from '@/page/problemDetail'
import appoint from '@/page/appoint'
import comment from '@/page/comment'
import canteenDetail from '@/page/canteenDetail'
import appointDetail from '@/page/appointDetail'
import scanSucess from '@/page/scanSucess'
import collection from '@/page/collection'
import news from '@/page/news'
import messagePage from '@/page/messagePage'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: home,
      meta: { title: '就餐' }
    },
    {
      path: '/order',
      name: 'order',
      component: order,
      meta: { title: '就餐记录' }
    },
    {
      path: '/canteen',
      name: 'canteen',
      component: canteen,
      meta: { title: '机关食堂' }
    },
    {
      path: '/mine',
      name: 'mine',
      component: mine,
      meta: { title: '我的' }
    },
    {
      path: '/search',
      name: 'search',
      component: search,
      meta: { title: '搜索' }
    },
    {
      path: '/problem',
      name: 'problem',
      component: problem,
      meta: { title: '问题库' }
    },
    {
      path: '/problemDetail',
      name: 'problemDetail',
      component: problemDetail,
      meta: { title: '详情' }
    },
    {
      path: '/appoint',
      name: 'appoint',
      component: appoint,
      meta: { title: '我的预约' }
    },
    {
      path: '/comment',
      name: 'comment',
      component: comment,
      meta: { title: '评价' }
    },
    {
      path: '/canteenDetail',
      name: 'canteenDetail',
      component: canteenDetail,
      meta: { title: '就餐详情' }
    },
    {
      path: '/appointDetail',
      name: 'appointDetail',
      component: appointDetail,
      meta: { title: '公务餐预约详情' }
    },
    {
      path: '/scanSucess',
      name: 'scanSucess',
      component: scanSucess,
      meta: { title: '扫码成功' }
    },
    {
      path: '/collection',
      name: 'collection',
      component: collection,
      meta: { title: '我的收藏' }
    },{
      path: '/news',
      name: 'news',
      component: news,
      meta: { title: '消息' }
    },{
      path: '/messagePage',
      name: 'messagePage',
      component: messagePage,
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js